/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyDram = createReactComponent("currency-dram", "IconCurrencyDram", [
  ["path", { d: "M4 10a6 6 0 1 1 12 0v10", key: "svg-0" }],
  ["path", { d: "M12 16h8", key: "svg-1" }],
  ["path", { d: "M12 12h8", key: "svg-2" }]
]);

export { IconCurrencyDram as default };
//# sourceMappingURL=IconCurrencyDram.js.map
